import React, {useState, useEffect} from "react";
import {
  BsFillArrowLeftCircleFill,
  BsFillArrowRightCircleFill,
} from "react-icons/bs";
import axios from "axios";

import "./Admission.css";

const ADMISSION_URL = "/keam-allotments";

function Admission() {
  const [year, setYear] = useState(2021);
  const [admission, setAdmission] = useState("");

  useEffect(() => {
    async function getSyllabus() {
      try {
        const response = await axios.get(
          process.env.REACT_APP_DEPT_API + ADMISSION_URL
        );
        setAdmission(response.data);
      } catch (error) {
        console.error(error);
      }
    }
    getSyllabus();
  }, []);

  const currentAdm =
    admission && admission.filter((x) => Number(x.year) === year);

  let maxYear =
    admission &&
    admission.reduce((acc, value) => {
      return (acc = acc > value.year ? acc : value.year);
    }, 0);

  const previousYear = () => {
    if (year > 2020) setYear(year - 1);
  };
  const nextYear = () => {
    if (year < maxYear) setYear(year + 1);
  };

  return (
    <div className="admission">
      <div className="section__container">
        <div className="section" data-aos="fade-up">
          <h1 className="section__header">Admission</h1>
          <p className="about__p">
            For B.Tech course, allotment to 95% (50% Merit- Regulated Fees and
            45% Merit- Full Fees) seats of the annual intake is made by the
            Commissioner for Entrance Examination (CEE), Government of Kerala
            from the rank list of Kerala Engineering Entrance Examination
            conducted every year by Government of Kerala. <br />
            5% seats are reserved for non resident Indians (NRI seats). For NRI
            admission, separate applications are invited by Model Engineering
            College and rank list is prepared on the basis of qualifying
            examination and students are admitted from this rank list.
            <br />
            We also offer M.Tech in Computer Science and Engineering with
            specialization in Data Science, with an annual intake of 18.
          </p>
          <div className="mid_sec">
            <div className="mid_sec_div">
              <div className="mid_circle">
                <h1>180</h1>
                <h5>Seats</h5>
              </div>
              <h2>B.Tech</h2>
            </div>
            <div className="mid_sec_div">
              <div className="mid_circle">
                <h1>18</h1>
                <h5>Seats</h5>
              </div>
              <h2>M.Tech</h2>
            </div>
          </div>
        </div>

        {/* <div className="section">
          <div className="admission_details">
            <h2>B.Tech - Last Rank Details</h2>
            <div className="students_header">
              <div className="section_slider">
                <BsFillArrowLeftCircleFill
                  onClick={previousYear}
                  className="slider_btn"
                  style={{
                    opacity: year === 2020 ? 0.5 : 1,
                    cursor: year === 2005 ? "auto" : "pointer",
                  }}
                />
                <h2>{year}</h2>
                <BsFillArrowRightCircleFill
                  onClick={nextYear}
                  className="slider_btn"
                  style={{
                    opacity: year === maxYear ? 0.5 : 1,
                    cursor: year === maxYear ? "auto" : "pointer",
                  }}
                />
              </div>
            </div>
            {currentAdm &&
              currentAdm.map((adm) => (
                <div className="admission_content" key={adm._id}>
                  <div className="allot_header">
                    <p>{adm.first_allotment.date_published}</p>
                    <h1>1st Allotment</h1>
                    <a
                      href={adm.first_allotment.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="mob_d_None">View Full </span> Allotment
                      List
                    </a>
                  </div>
                  <div className="allot_details">
                    <div className="allot_col1">
                      <h3>Category</h3>
                      <h3 className="border_btm_adm">Last Rank</h3>
                    </div>
                    <div className="allot_col2">
                      {adm.first_allotment.allotments &&
                        adm.first_allotment.allotments.map((all, id) => (
                          <div className="single__allot" key={id}>
                            <div className="allot_cat">
                              <p>{all.category}</p>
                            </div>
                            <div className="allot_rank">
                              <p>{all.rank}</p>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>

                  <div className="allot_header">
                    <p>{adm.second_allotment.date_published}</p>
                    <h1>2nd Allotment</h1>
                    <a
                      href={adm.second_allotment.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="mob_d_None">View Full </span> Allotment
                      List
                    </a>
                  </div>
                  <div className="allot_details">
                    <div className="allot_col1">
                      <h3>Category</h3>
                      <h3 className="border_btm_adm">Last Rank</h3>
                    </div>
                    <div className="allot_col2">
                      {adm.second_allotment.allotments &&
                        adm.second_allotment.allotments.map((all, id) => (
                          <div className="single__allot" key={id}>
                            <div className="allot_cat">
                              <p>{all.category}</p>
                            </div>
                            <div className="allot_rank">
                              <p>{all.rank}</p>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>

                  <div className="allot_header">
                    <p>{adm.third_allotment.date_published}</p>
                    <h1>3rd Allotment</h1>
                    <a
                      href={adm.third_allotment.link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="mob_d_None">View Full </span> Allotment
                      List
                    </a>
                  </div>
                  <div className="allot_details">
                    <div className="allot_col1">
                      <h3>Category</h3>
                      <h3 className="border_btm_adm">Last Rank</h3>
                    </div>
                    <div className="allot_col2">
                      {adm.third_allotment.allotments &&
                        adm.third_allotment.allotments.map((all, id) => (
                          <div className="single__allot" key={id}>
                            <div className="allot_cat">
                              <p>{all.category}</p>
                            </div>
                            <div className="allot_rank">
                              <p>{all.rank}</p>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default Admission;
